export const playUserAudioPromise = (
  url,
  {
    timeoutMs = 30000,
    debugLabel = 'audio',
    startDelayMs = 0,
    signal = null,
  } = {}
) => {
  return new Promise((resolve) => {
    const audio = new Audio(url);
    let settled = false;
    let watchdogTimer = null;
    let startTimer = null;

    const onAbort = () => {
      try {
        audio.pause();
      } catch (_) {
        // no-op
      }
      finish({ played: false, reason: 'aborted' });
    };

    const cleanup = () => {
      audio.onended = null;
      audio.onerror = null;

      if (watchdogTimer) {
        clearTimeout(watchdogTimer);
        watchdogTimer = null;
      }

      if (startTimer) {
        clearTimeout(startTimer);
        startTimer = null;
      }

      if (signal) {
        signal.removeEventListener('abort', onAbort);
      }
    };

    const finish = (result) => {
      if (settled) return;
      settled = true;
      cleanup();
      resolve(result);
    };

    const startPlayback = () => {
      watchdogTimer = setTimeout(() => {
        try {
          audio.pause();
          audio.currentTime = 0;
        } catch (_) {
          // no-op
        }

        console.warn(`[${debugLabel}] watchdog timeout`, { url, timeoutMs });
        finish({ played: false, reason: 'timeout' });
      }, timeoutMs);

      audio.onended = () => {
        finish({ played: true, ended: true });
      };

      audio.onerror = (e) => {
        console.warn(`[${debugLabel}] error`, e);
        finish({ played: false, reason: 'error' });
      };

      audio.play().catch((e) => {
        console.warn(`[${debugLabel}] play rejected`, e);
        finish({ played: false, reason: 'play_rejected' });
      });
    };

    if (signal) {
      if (signal.aborted) {
        onAbort();
        return;
      }
      signal.addEventListener('abort', onAbort);
    }

    if (startDelayMs > 0) {
      startTimer = setTimeout(startPlayback, startDelayMs);
      return;
    }

    startPlayback();
  });
};
